import { render, staticRenderFns } from "./ColorSelectButton.vue?vue&type=template&id=0d7ffd6c&scoped=true"
import script from "./ColorSelectButton.vue?vue&type=script&lang=js"
export * from "./ColorSelectButton.vue?vue&type=script&lang=js"
import style0 from "./ColorSelectButton.vue?vue&type=style&index=0&id=0d7ffd6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ffd6c",
  null
  
)

export default component.exports